import React, { useState, useEffect } from "react";
import "./Style/Digitalclock.css";

export default function Digitalclock() {
  const [stime, setStime] = useState(0);
  const [mtime, setMtime] = useState(0);
  const [htime, setHtime] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      let d = new Date();
      setHtime(d.getHours());
      setMtime(d.getMinutes());
      setStime(d.getSeconds());
    }, 1000);
  }, [htime, mtime, stime]);

  return (
    <div className="content">
      <h1>{`${htime < 10 ? `0` + htime : htime}:${
        mtime < 10 ? `0` + mtime : mtime
      }:${stime < 10 ? `0` + stime : stime}`}</h1>
      <p>IST</p>
    </div>
  );
}
